module.exports = __webpack_public_path__ + "img/drag1.6ff6658b.svg";